import { useContext, useEffect, useState } from "react";
import BryntumContext from "../../../../context/bryntumContext.jsx";
import { SWIVU_HOME_VIEW } from "@/other/constants/OtherKeys.jsx";
import AuthContext from "../../../../context/authContext.jsx";
import { Avatar, AvatarFallback, AvatarImage } from "@/modern/components/ui/avatar";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/modern/components/ui/dropdown-menu";

const AppUserAvatarButton = () => {
  const { user, logout, setDisplayAuthForm } = useContext(AuthContext);
  const { selectedBoard, boardManager } = useContext(BryntumContext);
  const [imageError, setImageError] = useState(false);
  const [userDetails, setUserDetails] = useState({
    displayName: "User",
    userProfileImageUrl: null,
    isDemoUser: false
  });

  const handleImageError = () => setImageError(true);

  useEffect(() => {
    if (user) {
      setUserDetails(prev => ({
        ...prev,
        displayName: user.first_name || "User",
        userProfileImageUrl: user.profile_image_url,
        isDemoUser: user.isDemoUser
      }));
    }
  }, [user]);

  const loginOrLogout = () => {
    if (userDetails.isDemoUser) {
      setDisplayAuthForm({
        type: SWIVU_HOME_VIEW.auth,
        data: {
          selectedBoard: selectedBoard.record,
          boards: boardManager.boardNameStore.records,
        }
      });
    } else {
      logout();
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <div className='flex items-center gap-2 cursor-pointer hover:opacity-80 transition-opacity h-11'>
          {imageError || userDetails.isDemoUser ? (
            <Avatar className="w-11 h-11">
              <AvatarFallback className="bg-blue-600 text-white font-semibold text-base">
                {userDetails.displayName ? userDetails.displayName.charAt(0).toUpperCase() : 'N/A'}
              </AvatarFallback>
            </Avatar>
          ) : (
            <Avatar className="w-11 h-11">
              <AvatarImage
                src={userDetails.userProfileImageUrl}
                alt="User Avatar"
                onError={handleImageError}
              />
              <AvatarFallback className="bg-blue-600 text-white font-semibold text-base">
                {userDetails.displayName ? userDetails.displayName.charAt(0).toUpperCase() : 'N/A'}
              </AvatarFallback>
            </Avatar>
          )}
          <i className="fa fa-chevron-down text-sm text-gray-600 dark:text-gray-400" />
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-32">
        <DropdownMenuItem onClick={loginOrLogout} className="cursor-pointer p-0">
          {userDetails.isDemoUser ? "Login" : "Logout"}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default AppUserAvatarButton;